// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1AH7d","requiredAsterisk":"Info_requiredAsterisk__CgUud"};